const makeChannel = (a: number, b: number, percent: number) => {
    return a + Math.round((b - a) * percent);
};

const parseHexToIntParts = (hex: { match: (arg0: RegExp) => any[] }) => {
    return hex.match(/.{2}/g).map((i) => parseInt(i, 16));
};

const parsePartsToHex = (parts: any) => {
    return parts
        .map((part) => {
            const res = part.toString(16);
            if (res.length < 2) {
                return `0${res}`;
            }
            return res;
        })
        .join('');
};

const calcRange = (start: any, end: any, perc: any) => {
    const startInt = parseHexToIntParts(start);
    const endInt = parseHexToIntParts(end);

    const result: any[] = [];

    [1, 2, 3].forEach((_, idx) => {
        result.push(makeChannel(startInt[idx], endInt[idx], perc));
    });
    return parsePartsToHex(result);
};
const calculateNewPercentage = (oldPercentage: any, step: any) => {
    const newPercentage = (oldPercentage - step) / 0.25;
    return +newPercentage.toFixed(4);
};
export const calcGradientByScore = (score: any, limit = 1000) => {
    const percentage = score / limit;
    let newPercentage = score / limit;
    // let topColorRange = ["f54526", "daf232"]; // ['f54526', 'f96429', 'daf232'];
    // let bottomColorRange = ["ed3253", "74ee64"]; // ['ed3253', 'feba4b', '74ee64'];
    let topColorRange: any[] = [];
    let bottomColorRange: any[] = [];

    if (percentage < 0.25) {
        newPercentage = calculateNewPercentage(percentage, 0);
        topColorRange = ['f64828', 'fa6529'];
        bottomColorRange = ['ed2f4c', 'ffbb4c'];
    } else if (percentage >= 0.25 && percentage < 0.5) {
        newPercentage = calculateNewPercentage(percentage, 0.25);
        topColorRange = ['fa6529', 'd9f232'];
        bottomColorRange = ['ffbb4c', '77ed64'];
    } else if (percentage >= 0.5 && percentage < 0.75) {
        newPercentage = calculateNewPercentage(percentage, 0.5);
        topColorRange = ['d9f232', 'daf131'];
        bottomColorRange = ['77ed64', '74ed63'];
    } else if (percentage >= 0.75) {
        newPercentage = calculateNewPercentage(percentage, 0.75);
        topColorRange = ['daf131', '00e586'];
        bottomColorRange = ['74ed63', '00d0cc'];
    }

    return [
        /** @ts-ignore */
        calcRange(...topColorRange, newPercentage),
        /** @ts-ignore */
        calcRange(...bottomColorRange, newPercentage),
    ];
};
